import React, {useContext} from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import RegisterForm from "../Validation/RegisterForm";
import Main from "../Flow/Main";
import LoginForm from "../Validation/LoginForm";
import AuthContext from "../Validation/AuthContext";
import LandingPage from "../Landing/LandingPage";
import Product from "../Landing/Product";
import About from "../Landing/About";
import Contact from "../Landing/Contact";


const Routs = () => {
    const {isAuthntificated} = useContext(AuthContext)

    return (
        <BrowserRouter>

            <Routes>
                {isAuthntificated ? <>
                        <Route path="/" element={<LoginForm/>}/>
                        <Route path="*" element={<LoginForm/>}/>
                        <Route path="/login" element={<LoginForm/>}/>
                        <Route path="/register" element={<RegisterForm/>}/>

                    </>
                    : <>

                        <Route path="App" element={<Main/>}/>
                        <Route path="*" element={<LandingPage/>}/>
                        <Route path="about" element={<About/>}/>
                        <Route path="contact" element={<Contact/>}/>
                        <Route path="product" element={<Product/>}/>
                    </>
                }


                {/*<Route index element={<Home />} />*/}
                {/*<Route path="teams" element={<Teams />}>*/}
                {/*    <Route path=":teamId" element={<Team />} />*/}
                {/*    <Route path="new" element={<NewTeamForm />} />*/}
                {/*    <Route index element={<LeagueStandings />} />*/}
            </Routes>
        </BrowserRouter>
    );
};

export default Routs;